const app = {
    title: 'Dashboard',
    subtitle: 'API-Monetarisierungsplattform',
    description: 'Multi-Tenant-SaaS für Automatisierungsagenturen',
    
    // Main sections
    apiProducts: 'API-Produkte',
    customerAnalytics: 'Kundenanalyse',
    quickActions: 'Schnellaktionen',
    
    // Status messages
    reactReady: 'React Bereit',
    shadcnReady: 'shadcn/ui Bereit',
    typescriptReady: 'TypeScript Bereit',
    configuredMessage: 'Wenn Sie diese wunderschön gestaltete Seite mit shadcn/ui-Komponenten sehen können, ist React vollständig konfiguriert und entwicklungsbereit!',
    
    // Test section
    reactTest: 'React Test',
    testDescription: 'Interaktive Tests zur Überprüfung der React-Funktionalität',
    stateManagementTest: 'State-Management-Test:',
    eventHandlerTest: 'Event-Handler-Test:',
    configurationStatus: 'Configuration-Status',
    allSystemsGo: 'Alle Systeme Einsatzbereit',
    environmentTitle: 'Umgebung',
    environmentDescription: 'Entwicklungsumgebungskonfiguration',
    
    // Button variants
    buttonVariants: 'shadcn/ui Button-Varianten',
    buttonDescription: 'Verschiedene Button-Stile und -Größen präsentieren',
    
    // Actions
    testReact: 'React Testen',
    testAgain: 'Erneut Testen',
    ghostStyle: 'Ghost-Stil',
    reset: 'Zurücksetzen',
    count: 'Zähler: {{count}}',
    
    // Environment info
    mode: 'Modus:',
    development: 'Entwicklung',
    apiUrl: 'API-URL:',
    notSet: 'Nicht gesetzt',
    hotReload: 'Hot Reload:',
    port: 'Port:',
    localDevelopment: 'Lokale Entwicklung',
  } as const;

export default app;
